import axios from 'axios';
import { BACKEND_BASEURL } from '@/config/config';

let configBackendBaseUrl = '';
let $log;

export default function setup(app) {
  configBackendBaseUrl = BACKEND_BASEURL;
  $log = app.$log;
}

/**
 * Fetch all billing master data (bill runs) from the backend.
 * @returns {Promise<Array>}
 */
export async function fetchAllBillruns() {
  try {
    const response = await axios.get(`${configBackendBaseUrl}billruns/all`);
    return response.data;
  } catch (error) {
    $log.error('Error fetching all bill runs:', error);
    throw error;
  }
}

/**
 * Fetch the latest data analysis result for a bill run.
 * @param {string} billrunIdentifier - Bill run run identifier
 * @returns {Promise<object|null>} Analysis object, or null if not found (404)
 */
export async function fetchAnalysisForBillrun(billrunIdentifier) {
  try {
    const response = await axios.get(
      `${configBackendBaseUrl}billruns/analysis-for-billrun/${encodeURIComponent(billrunIdentifier)}`
    );
    return response.data ?? null;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    $log.error(`Error fetching analysis for billrun ${billrunIdentifier}:`, error);
    throw error;
  }
}
